<div class="cell shrink">
    <i class="far fa-clock reservationTimeLeft-icon"></i>
</div>
<div class="cell shrink">
    {{'label.end' | translate}} : {{time}}
</div>
